import roles from '@/constants/roles';
import clientRoles from '@/constants/clientRoles';

export default Object.freeze([
    {
        title: 'clientPage.sites',
        path: { name: 'sites' },
        icon: 'site.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'clientPage.clientInfo',
        path: { name: 'info' },
        icon: 'ClientInfo.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'clientPage.contacts',
        path: { name: 'contacts' },
        icon: 'Contacts.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'clientPage.assignedUsers',
        path: { name: 'assignedUsers' },
        icon: 'AssignedUsers.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
        ],
    },
    {
        title: 'clientPage.manageClientTeam',
        path: { name: 'manageClientTeam' },
        icon: 'ManageClientTeam.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
        ],
    },
]);
